module.exports = __webpack_public_path__ + "img/ext12.4231a52e.jpg";